namespace Matrix.Data {
    export interface DateRow {
        DateKey?: string;
        RowId?: number;
        DateName?: string;
        DayOfWeek?: number;
        DayNameOfWeek?: string;
        DayOfMonth?: number;
        DayOfYear?: number;
        WeekdayWeekend?: string;
        WeekOfYear?: number;
        MonthName?: string;
        MonthOfYear?: number;
        IsLastDayOfMonth?: string;
        CalendarQuarter?: number;
        CalendarYear?: number;
        CalendarYearMonth?: string;
        CalendarYearQtr?: string;
        FiscalMonthOfYear?: number;
        FiscalQuarter?: number;
        FiscalYear?: number;
        FiscalYearMonth?: string;
        FiscalYearQtr?: string;
        IsBusinessDay?: string;
        IsLastBusinessDayOfMonth?: string;
        IsFirstBusinessDayOfMonth?: string;
    }

    export namespace DateRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'DateName';
        export const localTextPrefix = 'Data.Date';
        export const deletePermission = 'NoPermission';
        export const insertPermission = 'NoPermission';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'NoPermission';

        export declare const enum Fields {
            DateKey = "DateKey",
            RowId = "RowId",
            DateName = "DateName",
            DayOfWeek = "DayOfWeek",
            DayNameOfWeek = "DayNameOfWeek",
            DayOfMonth = "DayOfMonth",
            DayOfYear = "DayOfYear",
            WeekdayWeekend = "WeekdayWeekend",
            WeekOfYear = "WeekOfYear",
            MonthName = "MonthName",
            MonthOfYear = "MonthOfYear",
            IsLastDayOfMonth = "IsLastDayOfMonth",
            CalendarQuarter = "CalendarQuarter",
            CalendarYear = "CalendarYear",
            CalendarYearMonth = "CalendarYearMonth",
            CalendarYearQtr = "CalendarYearQtr",
            FiscalMonthOfYear = "FiscalMonthOfYear",
            FiscalQuarter = "FiscalQuarter",
            FiscalYear = "FiscalYear",
            FiscalYearMonth = "FiscalYearMonth",
            FiscalYearQtr = "FiscalYearQtr",
            IsBusinessDay = "IsBusinessDay",
            IsLastBusinessDayOfMonth = "IsLastBusinessDayOfMonth",
            IsFirstBusinessDayOfMonth = "IsFirstBusinessDayOfMonth"
        }
    }
}
